import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/taxes/create',
    name: 'create_taxes',
    component: () => import('@/views/pages/taxes/CreateTaxes.vue'),
    meta: {
      pageTitle: 'Create Taxes',
      breadcrumb: {
        label: 'Create Taxes',
        parent: 'taxes'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/taxes/:id',
    name: 'taxes_detail',
    component: () => import('@/views/pages/taxes/EditTaxes.vue'),
    meta: {
      pageTitle: 'Edit Taxes',
      breadcrumb: {
        label: 'Edit Taxes',
        parent: 'taxes'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/taxes',
    name: 'taxes',
    component: () => import('@/views/pages/taxes/TaxesList.vue'),
    meta: {
      pageTitle: 'Taxes',
      breadcrumb: {
        label: 'Taxes'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN],
      verticalMenu: {
        title: 'Taxes',
        icon: 'HomeIcon',
        parent: 'priceManagement'
      }
    }
  }
];
